import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

const PRODUCTS_BASE_URL = 'products';
export const sellerProductsService = {
  getProducts: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}`, { params });
    return response.data;
  },

  searchProducts: async (params = {}) => {
    const response = await api.get(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/search`, { params });
    return response.data;
  },

  getProductStats: async () => {
    const response = await api.get(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/stats`);
    return response.data;
  },

  getProduct: async (productId) => {
    const response = await api.get(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/${productId}`);
    return response.data;
  },

  createProduct: async (productData) => {
    const response = await api.post(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}`, productData);
    return response.data;
  },

  updateProduct: async (productId, productData) => {
    const response = await api.put(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/${productId}`, productData);
    return response.data;
  },

  deleteProduct: async (productId) => {
    const response = await api.delete(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/${productId}`);
    return response.data;
  },

  bulkUploadProducts: async (formData) => {
    const response = await api.post(`${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/bulk-upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Download bulk upload template for products.
   * Returns the raw Axios response (blob) so callers can handle download.
   */
  downloadBulkUploadTemplate: async () => {
    const response = await api.get(
      `${SELLER_V1_BASE}/${PRODUCTS_BASE_URL}/download-template`,
      { responseType: 'blob' }
    );
    return response;
  },

  getBrandCategories: async () => {
    const response = await api.get(`${SELLER_V1_BASE}/brand-categories`);
    return response.data;
  },
};

export default sellerProductsService;
